import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Create,
  getCurrency,
  getPaymentMethod
} from "adminApi/PaymentSetupApi/PaymentSetup";
import fields from "../json/PaymentSetupFeilds.json";
import { validateForm } from "utils/validation";
import { PaymentSetupValidationRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddPaymentSetupForm from "./Componates/AddPaymentSetupForm";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchAllData from "Hooks/useFetchAllData";


const AddPaymentSetup = () => {      
  const navigate = useNavigate();
  const { formdata } = fields;

  // Initialize form values
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange} = useFormChange(initialValues, PaymentSetupValidationRules);

    //Get Payment Method
    const { data:PaymentMethodOptions , loading: loadingPaymentMethod } = useFetchAllData(getPaymentMethod);
  
    //Get Currency
    const { data:CurrencyOptions , loading: loadingCurrency } = useFetchAllData(getCurrency);

  // Form submit hook
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
      return await Create({data:formData});
    },
    (vals) =>{
      const err = validateForm(vals, PaymentSetupValidationRules)
      console.log("err",err);
      return err;
    },
    () =>{ 
      return navigate(-1)
    },
    "Payment Setup Created successfully"
  );
  return (
    <>
      {(loadingSubmit || loadingPaymentMethod || loadingCurrency) && <Spinner isSpinner={true} />}
      <AddPaymentSetupForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="Create Payment Setup"
        PaymentMethodOptions={PaymentMethodOptions}
        CurrencyOptions={CurrencyOptions}
      />
    </>
  );
};

export default AddPaymentSetup;
